(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  /* Carrello DENTRO il menu laterale: apre il drawer sopra il menu invece di
     navigare a /cart. Sul live è un Button con onClick={() => openCartDrawer(true)}
     e il menu resta aperto (misurato: due dialog aperti sovrapposti, URL invariato).
     Delegato sul documento perché il markup del drawer viene ri-renderizzato
     dall'editor del tema. */
  document.addEventListener('click', (event) => {
    const trigger = event.target.closest('.iv-menu__cart');
    if (!trigger) return;
    const drawer = document.querySelector('cart-drawer');
    if (!drawer || typeof drawer.open !== 'function') return; // senza drawer: naviga
    event.preventDefault();
    drawer.open();
  });

  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  // Modal lingua/paese mobile (replica SelectLocale + Dialog headless)
  class IvLocaleDialog extends HTMLElement {
    connectedCallback() {
      this.trigger = this.querySelector('.iv-locale-dialog__trigger');
      this.overlay = this.querySelector('.iv-locale-dialog__overlay');
      this.card = this.querySelector('.iv-locale-dialog__card');
      if (!this.trigger || !this.overlay) return;
      this.trigger.addEventListener('click', () => this.open());
      this.querySelector('.iv-locale-dialog__close').addEventListener('click', () => this.close());
      this.overlay.addEventListener('click', (event) => {
        if (event.target === this.overlay) this.close();
      });
      this.addEventListener('keyup', (event) => {
        if (event.code === 'Escape') this.close();
      });
    }

    open() {
      this.overlay.classList.remove('iv-closing');
      this.overlay.removeAttribute('hidden');
      this.trigger.setAttribute('aria-expanded', 'true');
      document.body.style.overflow = 'hidden';
      this.card.focus();
    }

    close() {
      // Exit come lo shadcn Dialog: fade+zoom 150ms, poi hidden
      if (this.overlay.hasAttribute('hidden') || this.overlay.classList.contains('iv-closing')) return;
      this.overlay.classList.add('iv-closing');
      setTimeout(() => {
        this.overlay.classList.remove('iv-closing');
        this.overlay.setAttribute('hidden', '');
      }, 150);
      this.trigger.setAttribute('aria-expanded', 'false');
      document.body.style.overflow = '';
      this.trigger.focus();
    }
  }

  customElements.define('iv-locale-dialog', IvLocaleDialog);

  // "Shop" si apre al passaggio del mouse come l'headless (radix NavigationMenu):
  // hover → open, uscita (trigger o panel) → close con piccola grazia.
  // Delegation sul documento: sopravvive ai re-render della sezione (theme editor).
  (() => {
    // Tempi misurati sull'ufficiale (radix NavigationMenu): apre ~200ms dopo
    // l'hover, chiude ~150ms dopo l'uscita con exit animation da 150ms.
    const mq = window.matchMedia('(min-width: 1024px)');
    let openTimer;
    let openTarget;
    let closeTimer;

    const closeWithExit = (details) => {
      if (!details.open || details.classList.contains('iv-closing')) return;
      details.classList.add('iv-closing');
      setTimeout(() => {
        details.classList.remove('iv-closing');
        details.open = false;
      }, 150);
    };

    document.addEventListener('mouseover', (event) => {
      if (!mq.matches || !event.target.closest) return;
      const details = event.target.closest('.header__inline-menu header-menu > details');
      if (!details) return;
      clearTimeout(closeTimer);
      if (details.open && !details.classList.contains('iv-closing')) return;
      // Non resettare il timer muovendosi tra i figli dello stesso trigger
      if (openTarget === details && openTimer) return;
      clearTimeout(openTimer);
      openTarget = details;
      openTimer = setTimeout(() => {
        openTimer = null;
        details.classList.remove('iv-closing');
        details.open = true;
      }, 200);
    });
    document.addEventListener('mouseout', (event) => {
      if (!mq.matches || !event.target.closest) return;
      const details = event.target.closest('.header__inline-menu header-menu > details');
      if (!details || details.contains(event.relatedTarget)) return;
      clearTimeout(openTimer);
      openTimer = null;
      openTarget = null;
      clearTimeout(closeTimer);
      if (details.open) closeTimer = setTimeout(() => closeWithExit(details), 150);
    });
    // Click sul trigger aperto: chiusura con exit animation (il toggle nativo
    // del details chiuderebbe di colpo)
    document.addEventListener(
      'click',
      (event) => {
        if (!mq.matches || !event.target.closest) return;
        const summary = event.target.closest('.header__inline-menu header-menu > details > summary');
        if (!summary) return;
        const details = summary.parentElement;
        if (details.open && !details.classList.contains('iv-closing')) {
          event.preventDefault();
          event.stopPropagation();
          closeWithExit(details);
        }
      },
      true
    );

    // Dropdown Paese/Lingua desktop: exit animation come l'headless (fade+zoom
    // 150ms). Dawn nasconde il pannello di colpo: si ritarda l'hidden di 150ms
    // con la classe .iv-closing (animata in iv-theme.css).
    customElements.whenDefined('localization-form').then(() => {
      const LocalizationForm = customElements.get('localization-form');
      const originalHide = LocalizationForm.prototype.hidePanel;
      const originalOpen = LocalizationForm.prototype.openSelector;

      // Contesti "popover" (pannello bianco stile radix): pill nell'header
      // desktop (visibili da 768, come l'ufficiale) e pill dentro il dialog
      // mobile. Il drawer menu resta con lo sheet Dawn.
      const isPopover = (form) =>
        (form.closest('.header__icons') && window.matchMedia('(min-width: 768px)').matches) ||
        form.closest('.iv-locale-dialog__card');

      LocalizationForm.prototype.hidePanel = function () {
        const panel = this.elements && this.elements.panel;
        if (!panel || panel.hidden || !isPopover(this) || panel.classList.contains('iv-closing')) {
          return originalHide.call(this);
        }
        this.elements.button.setAttribute('aria-expanded', 'false');
        panel.classList.add('iv-closing');
        setTimeout(() => {
          panel.classList.remove('iv-closing');
          // Riaperto durante l'uscita: non nascondere
          if (this.elements.button.getAttribute('aria-expanded') === 'true') return;
          originalHide.call(this);
        }, 150);
      };

      // ⚠ Dawn binda openSelector al click PRIMA di questa patch
      // (this.openSelector.bind(this) nel connectedCallback cattura la
      // versione originale) → la logica click va in capture sul documento.
      document.addEventListener(
        'click',
        (event) => {
          if (!event.target.closest) return;
          const button = event.target.closest('.disclosure__button.localization-selector');
          if (!button) return;
          const form = button.closest('localization-form');
          if (!form || !form.elements || !isPopover(form)) return;
          const panel = form.elements.panel;
          if (!panel) return;
          // Riaperto durante l'exit: annulla la chiusura
          if (panel.classList.contains('iv-closing')) {
            event.preventDefault();
            event.stopImmediatePropagation();
            panel.classList.remove('iv-closing');
            form.elements.button.setAttribute('aria-expanded', 'true');
            return;
          }
          // Pill cliccata col menu aperto: exit animation invece del toggle secco
          if (!panel.hidden) {
            event.preventDefault();
            event.stopImmediatePropagation();
            form.hidePanel();
            return;
          }
          // Collision clamp come radix (misurato sull'ufficiale: il pannello
          // 224px centrato sulla pill si ferma al bordo viewport, x=0)
          if (form.closest('.iv-locale-dialog__card')) {
            const r = button.getBoundingClientRect();
            const natural = r.left + r.width / 2 - 112;
            const target = Math.max(0, Math.min(natural, window.innerWidth - 224));
            panel.style.marginLeft = target - natural + 'px';
          }
        },
        true
      );
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
